import React from "react"
import { Container, Row, Col } from "reactstrap"
import { appConstants } from "../../constants/app_constants"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © {appConstants.cName}.</Col>
            {/* <Col md={6}>
              <div className="text-sm-right d-none d-sm-block">
                Design & Develop
              </div>
            </Col> */}
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
